<template>
  <div>
    <div>
      <!-- Menú lateral -->
      <div v-if="$route.meta.partnerMenu" class="z-1">
        <!-- Botón para mostrar el menú -->
        <button @click="toggleSidebar" class="btn d-md-none m-1 z-1" style="color: var(--primary-color); font-size:30px; position: fixed">
          <i :class="isSidebarVisible ? '' : 'fa-solid fa-bars'"></i>
        </button>
        <div class="powered d-md-block p-3 z-1" style="top:0; right: 0;">
          <span class="me-2">Powered by</span>
          <img style="width: auto; height: 14px;" src="../src/assets/logo_Negro.png"/> 
        </div>
        <div class="w-100 z-2 d-md-none" :class="{ 'd-none': !isSidebarVisible }" style="width:100vh; height: 100%; position: absolute; background: rgba(139, 139, 139, 0.5); top:0px" @click="toggleSidebar"></div>
        <div id="left-menu" ref="menu" :class="{ 'header_partner': true, 'd-none': !isSidebarVisible, 'd-block': isSidebarVisible, 'd-flex': true, 'flex-column': true, 'justify-content-start': true, 'vh-100': true }" style="background-color: #091E33; z-index: 3; position: relative;">
          <div v-if="ewu_profesional" class="d-flex align-items-center justify-content-center" style="position: absolute; top: 0; width: 100%; height: 60px;">
            <router-link to="/PanelComandas" target="_blank" class="text-warning text-decoration-none text-center w-100" style="font-size: 1rem; padding: 10px 0;">
              <i class="fa-solid fa-arrow-left me-1"></i>
              Modo camarero
            </router-link>
          </div>
          <div class="w-100 d-flex justify-content-center align-items-center mt-5">
            <img :src="restaurant_logo || require('../src/assets/EWU_Blanco.png')" class="col-sm-8 col-12 px-1 logoPartner">
          </div>
          <p class="mt-3 text-center text-white mb-1 fw-semibold" style="font-size: 1.4rem;">Modo Admin</p>
          <p class="text-center" style="font-size: 0.8rem;">
            <router-link to="ChangePass" target="_blank" class="text-decoration-none text-warning">Cambiar contraseña</router-link>
          </p>
          <ul class="mt-3 list-group py-3 text-md-start text-center" style="font-size: 1.2rem;">
            <li class="mb-3 rounded-1 p-2" :class="{ selected: this.$route.path === '/PartnerSettings' }">
              <router-link to="/PartnerSettings" class="no-link-style">
                <i class="fa-solid fa-gear me-md-3"></i>
                Ajustes
              </router-link>
            </li>
            <li class="mb-3 rounded-1 p-2" :class="{ selected: this.$route.path === '/GestionCarta' }">
              <router-link to="/GestionCarta" class="no-link-style">
                <i class="fa-solid fa-utensils me-md-3"></i>
                Carta
              </router-link>
            </li>
            <li v-if="ewu_profesional" class="mb-3 rounded-1 p-2" :class="{ selected: this.$route.path === '/GestionMesas' }">
              <router-link to="/GestionMesas" class="no-link-style">
                <i class="fa-solid fa-chair me-md-3"></i>
                Mesas
              </router-link>
            </li>
            <li v-if="ewu_profesional" class="mb-3 rounded-1 p-2" :class="{ selected: this.$route.path === '/GestionCamareros' }">
              <router-link to="/GestionCamareros" class="no-link-style">
                <i class="fa-solid fa-users me-md-3"></i>
                Camareros
              </router-link>
            </li>
            <li v-if="ewu_profesional" class="mb-3 rounded-1 p-2" :class="{ selected: this.$route.path === '/DashboardPartner' }">
              <router-link to="/DashboardPartner" class="no-link-style">
                <i class="fa-solid fa-chart-pie me-md-3"></i>
                Dashboard
              </router-link>
            </li>
            <li class="mb-3 rounded-1 p-2" :class="{ selected: this.$route.path === '/MandarIncidencias' }">
              <router-link to="/MandarIncidencias" class="no-link-style">
                <i class="fa-solid fa-message me-md-3"></i>
                Incidencias
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!--FIN MENU LATERAL DEL PARTNER-->
  <!--PAGE DEL PARTNER-->
  <router-view class="pagePartner" v-if="$route.meta.partnerMenu" :ewu_profesional="ewu_profesional" @ReviseSession="ReviseSession"/>
  <!--PAGE DEL USER Y CAMARERO-->
  <router-view class="page" id="pagina" :max_plates="max_plates" :is_delivery="is_delivery" :open_kitchen="open_kitchen" :is_take_away="is_take_away" @ReviseSession="ReviseSession" v-else-if="!$route.meta.fullpage"/>
  <router-view class="page" style="height: 100vh" :max_plates="max_plates" :is_delivery="is_delivery" :open_kitchen="open_kitchen" :is_take_away="is_take_away" @ReviseSession="ReviseSession" v-else/>
  <!--MENU DEL USER-->
  <footer v-if="$route.meta.showFooter">
    <div class="row m-0 pt-3" :class="{ 'bg-white': (is_delivery || is_take_away) }">
      <router-link to="/Home" class="col-3 text-decoration-none">
          <i class="fa-solid fa-utensils fs-3 w-100 text-center text-nav"></i>
          <p class="button-text text-center text-nav">Carta</p>
      </router-link>
      <router-link to="/Carrito" class="col-3 text-decoration-none pe-4 carrito" >
          <span class="amount-carrito px-2">{{carrito}}</span>
          <i class="fa-solid fa-basket-shopping fs-3 w-100 text-center text-nav"></i>
          <p class="button-text text-center mb-0 text-nav">
            Carrito
          </p>
      </router-link>
      <router-link to="/MisPedidos" class="col-3 text-decoration-none ps-4">
          <i class="fas fa-rectangle-list fs-3 w-100 text-center text-nav"></i>
          <p class="button-text text-center mb-0 text-nav">Pedidos</p>
      </router-link>
      <router-link to="/Cuenta" class="col-3 text-decoration-none">
          <i class="fas fa-receipt fs-3 w-100 text-center text-nav"></i>
          <p class="button-text text-center mb-0 text-nav">Cuenta</p>
      </router-link>
    </div>
  </footer>
  <div  class="phone-icon d-flex align-items-center shadow" v-if="$route.meta.showFooter && !is_delivery && !is_take_away" @click="OpenCallWaiter()">
    <i class="fas fa-phone fs-2 w-100 text-center text-nav" style="transform: rotate(-270deg)"></i>
  </div>
  <svg class="footer-rounded" viewBox="0 0 100 20" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" v-if="$route.meta.showFooter && !is_delivery && !is_take_away">
      <path d="M0 0H42Q50 9 59 -1H100V100H0Z" fill="white" />
  </svg>
  <div class="restaurant-logo" v-if="restaurant_logo && $route.meta.showFooter">
    <img :src="restaurant_logo" alt="Logo restaurante" />
  </div>
  <div class="powered" v-if="$route.meta.showFooter">
    <span class="me-2">Powered by</span>
    <img style="width: auto; height: 14px;" src="../src/assets/logo_Negro.png"/> 
  </div>
  <!--FIN MENU DEL USER-->
  <!--INICIO MENU DEL CAMARERO-->
  <footer v-if="$route.meta.showFooterWaiter" class="bg-white shadow">
    <div class="row m-0 pt-3">
      <router-link to="/PanelComandas" class="col-4 text-decoration-none">
          <i class="fa-solid fa-list fs-3 w-100 text-center text-nav"></i>
          <p class="button-text text-center text-nav">Comandas</p>
      </router-link>
      <router-link to="/PanelMesas" class="col-4 text-decoration-none carrito" >
          <i class="fa-solid fa-chair fs-3 w-100 text-center text-nav"></i>
          <p class="button-text text-center mb-0 text-nav">Mesas</p>
      </router-link>
      <router-link to="/AccesoMesas" class="col-4 text-decoration-none carrito" >
          <i class="fa-solid fa-pen-to-square fs-3 w-100 text-center text-nav"></i>
          <p class="button-text text-center mb-0 text-nav">Apuntar</p>
      </router-link>
    </div>
  </footer>
  <LlamadaCamarero></LlamadaCamarero>

  <!-- Botón flotante para mostrar/ocultar el dropdown de idiomas -->
  <div v-if="!['/', '/login', '/LoginAdmin'].includes($route.path)" class="dropdown translate-dropdown position-fixed" style="z-index: 1050;">    
    <button class="btn text-white translate-btn rounded-4" style="background-color: var(--primary-color);" type="button" data-bs-toggle="dropdown" aria-expanded="false">
      <i class="bi bi-translate"></i>
    </button>
    <ul class="dropdown-menu dropdown-menu-end">     
      <li><a class="dropdown-item" @click="translate('es')"><span class="flag-icon flag-icon-es me-2"></span>  Español</a></li>
      <li><a class="dropdown-item" @click="translate('ca')"><img src="@/assets/catalunya_flag.svg" class="flag-icon me-2" />  Català</a></li>
      <li><a class="dropdown-item" @click="translate('gl')"><img src="@/assets/galicia_flag.svg" class="flag-icon me-2" />  Galego</a></li>
      <li><a class="dropdown-item" @click="translate('eu')"><img src="@/assets/vasca_flag.svg" class="flag-icon me-2" />  Euskara</a></li>
      <li><a class="dropdown-item" @click="translate('en')"><span class="flag-icon flag-icon-gb me-2"></span>  Inglés</a></li>
      <li><a class="dropdown-item" @click="translate('ar')"><span class="flag-icon flag-icon-ma me-2"></span>  Marroquí</a></li>
      <li><a class="dropdown-item" @click="translate('fr')"><span class="flag-icon flag-icon-fr me-2"></span>  Français</a></li>
      <li><a class="dropdown-item" @click="translate('pt')"><span class="flag-icon flag-icon-pt me-2"></span>  Português</a></li>
    </ul>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import axios from 'axios';
  import router from '@/router';
  import LlamadaCamarero from '@/components/LlamadaCamarero.vue'
  import { applyRestaurantCustoms } from '@/utils/restaurant_customs.js';

  export default {
    name: 'App',
    data() {
      return {
        carrito: 0,
        loginsFallidos: 0,
        max_plates: null,
        isSidebarVisible: true,
        is_delivery: false,
        is_take_away: false,
        open_kitchen: true,
        ewu_profesional: false,
        restaurant_logo: '',
      }
    },
    components: {
      LlamadaCamarero
    },
    computed:{
        ...mapState(['isLoggedIn']),
        ...mapState(['token']),
        ...mapState(['partner_token']),
        ...mapState(['refresh']),
    },
    methods:{
      logout() {
        this.$store.commit('logout');
      },
      OpenCallWaiter(){
        document.getElementById("waiter_call").classList.remove("d-none")
      },
      async ReviseSession(){
        //console.log("Token: " + this.token)
        //console.log("Partner Token: " + this.partner_token)
        //console.log("Refresh: " + this.refresh)
        //console.log("Fallidos: " + this.loginsFallidos)
        if (this.$route.meta.authorized){
          if (this.token != "null" && this.token != null){
            const token = this.token; // Suponiendo que tienes el token almacenado en Vuex
            const url = process.env.VUE_APP_API_URL+'/v1/api/app/me_table';
            try {
              const response = await axios.get(url, {
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              });
              this.loginsFallidos = 0;
              //console.log(response.data);
              this.carrito = response.data.shopping_cart_amount
              this.is_delivery = response.data.is_delivery
              this.is_take_away = response.data.is_take_away
              this.max_plates = response.data.max_plates
              this.open_kitchen = response.data.open_kitchen

              if (response.data.restaurant.customization) {
                const customization = response.data.restaurant.customization;
                if (customization.primary_color){
                  sessionStorage.setItem('restaurant_primary_color', customization.primary_color);
                }
                if (customization.secondary_color){
                  sessionStorage.setItem('restaurant_secondary_color', customization.secondary_color);
                }
                if (customization.logo){
                  this.restaurant_logo = customization.logo
                  console.log("logo empresa " + customization.logo)
                }
                applyRestaurantCustoms();
              }

              this.$store.dispatch('setUserAllowedToCancel', response.data.restaurant.user_allowed_to_cancel_order);
            } catch (error) {
              this.loginsFallidos++;
              if (this.loginsFallidos > 0) {
                router.push({ name: "Unauthorized" });
              }
              console.error('Error fetching shopping cart:', error);
            }
          } else {
            this.loginsFallidos++;
            if (this.loginsFallidos > 0) {
              router.push({ name: "Unauthorized" });
            }
          }
        }else if(this.$route.meta.showFooterWaiter || this.$route.meta.partnerMenu){
          //console.log("estoy modo partner")
          console.log(this.partner_token)
          //console.log(this.refresh)
          if (this.partner_token != "null" && this.partner_token != null){
            let url = process.env.VUE_APP_API_URL+'/v1/api/partner/verify';
            try {
              let token = {
                token: this.partner_token
              }
              const response = await axios.post(
                url,
                token,  // Aquí envías el `token` como cuerpo de la solicitud
                {
                  headers: {
                    'Content-Type': 'application/json'  // Establece los encabezados correctos si es necesario
                  }
                }
              );
              this.ewu_profesional = response.data.ewu_profesional
              if(!this.ewu_profesional){
                if(this.$route.path.includes("GestionMesas") || this.$route.path.includes("GestionCamareros") || this.$route.path.includes("DashboardPartner")){
                  this.$router.push({ name: "PartnerSettings" });
                }
                else if(this.$route.path.includes("PanelMesas") || this.$route.path.includes("PanelComandas") || this.$route.path.includes("AccesoMesas")){
                  this.$router.push({ name: "Login" });
                }
              }

              const partnerResponse = await axios.get(process.env.VUE_APP_API_URL + '/v1/api/partner/me', {
                headers: {
                  'Authorization': `Bearer ${this.partner_token}`
                }
              });

              if (partnerResponse.data.restaurant_logo) {
                this.restaurant_logo = `${partnerResponse.data.restaurant_logo}?t=${new Date().getTime()}`;
              } else {
                this.restaurant_logo = null;
              }

              //console.log(response.data)
            } catch (error) {
              url = process.env.VUE_APP_API_URL+'/v1/api/partner/refresh'
              try {
                let refresh = {
                  refresh: this.refresh
                }
                const response2 = await axios.post(
                  url,
                  refresh,  // Aquí envías el `token` como cuerpo de la solicitud
                  {
                    headers: {
                      'Content-Type': 'application/json'  // Establece los encabezados correctos si es necesario
                    }
                  }
                );
                console.log(response2.data)
                this.$store.dispatch('setToken', response2.data);
                console.log(this.partner_token)
              } catch (error) {
                console.error('Error refresh:', error);
                this.loginsFallidos++
                if (this.loginsFallidos > 0){
                  router.push({ name: "Login" });
                }
              }
              console.error('Error pair:', error);
            }
          }else{
            this.loginsFallidos++
            if (this.loginsFallidos > 0){
              router.push({ name: "Unauthorized" });
            }
          }
        }
      },
      startPolling() {
        this.pollingInterval = setInterval(this.ReviseSession, 15000); // Cada 15 segundos
      },
      stopPolling() {
        clearInterval(this.pollingInterval);
      },
      toggleSidebar() {
        this.isSidebarVisible = !this.isSidebarVisible;
        document.body.classList.toggle('no-scroll', this.isSidebarVisible);
      },
      translate(lang) {
        const host = location.hostname;
        const isHttps = location.protocol === 'https:';

        const baseAttrs = ['path=/', ...(host.endsWith('ewu.es') ? ['domain=.ewu.es'] : []), ...(isHttps ? ['SameSite=None', 'Secure'] : [])].join('; ');

        // borrar todas las variantes primero
        document.cookie = `googtrans=; max-age=0; path=/; domain=.ewu.es`;
        document.cookie = `googtrans=; max-age=0; path=/`;

        // setear la buena
        document.cookie = `googtrans=/es/${lang}; max-age=${60 * 60 * 24 * 365}; ${baseAttrs}`;

        window.location.reload();
      }
    },
    mounted() {
      if (window.innerWidth <= 768) {
        this.isSidebarVisible = false;
      }

      this.startPolling();

      const forceTitle = () => {
        const title = document.querySelector('title');
        if (!title) return;

        const observer = new MutationObserver(() => {
          if (document.title !== 'Eat With Us') {
            document.title = 'Eat With Us';
          }
        });

        observer.observe(title, { childList: true });
      };

      forceTitle();
    },
    beforeUnmount() {
      this.stopPolling();
    },
    watch: {
      '$route.meta.authorized': {
        handler(newValue) {
          if (typeof newValue !== 'undefined') {
            this.ReviseSession();
          }
        },
        immediate: true, // Ejecuta el watch inmediatamente
      }
    }
  };
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&family=Poppins:wght@400;500;600;800;900&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,100..700;1,100..700&display=swap');


  * {
    font-family: 'Poppins', sans-serif;
    
  }
  body{
    background-color: #f5f5f5 !important;
  }

  .text-nav{
    color:var(--primary-color);
  }

  footer{
    position: fixed;
    bottom: 0;
    width: 100vw; 
    height: 80px;
    
    z-index: 10;
    background-color: transparent;
  }

  .footer-rounded{
    position: fixed;
    z-index: 0;
    bottom: 0;
    width: 100vw; 
    height: 80px;
  }

  .page{
    position: fixed;
    /*height: 100vh !important;*/
    height: calc(100% - 80px);
    /*padding-bottom: 8vh;*/
    top:0;
    overflow-y: scroll;
    width: 100%;
    background-color: rgb(243, 243, 243) !important;
  }

  .phone-icon{
    position: fixed;
    bottom:70px;
    left: 44%;
    z-index: 1000;
    height: 50px;
    width: 12%;
    border-radius: 100px;
    background-color: white;
  }

  .powered{
    position: fixed;
    z-index: 10;
    bottom: 90px;
    right: 3vw;
    font-size: 0.7rem;
    pointer-events: none;
  }

  .powered span{
    color:var(--primary-color);
    font-weight: bold;
  }

  .powered img{
    height: 18px;
    width: auto;
  }

  .amount-carrito{
    position:fixed;
    margin-left:12vw;
    margin-top: -11px;
    color: white;
    background-color: var(--primary-color);
    border-radius: 100px;
  }

  nav,
    .offcanvas {
      background-color: #1e293b;
    }
    .navbar-toggler {
      border: none;
    }
    .navbar-toggler:focus {
      outline: none;
      box-shadow: none;
    }

    .selected{
      color: var(--primary-color) !important;
      background-color: white;
    }

    .pagePartner{
      margin-left: 18% !important;
      width: 82% !important;
      padding: 0px 2% 0px 2%;
      position: fixed;
      height: 100% !important;
      overflow-y: scroll;
      width: 100%;
    }

    .no-link-style {
      text-decoration: none;
      color: inherit;
      cursor: pointer;
    }

    .no-scroll {
      overflow: hidden;
    }

    .header_partner {
      width: 18%;
      position: fixed;
      top: 0;
      height: 100vh;
      z-index: 10;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
    }

    .header_partner .list-group {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .header_partner .list-group li {
      color: white;
      padding: 10px 20px;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      font-size: 1.2rem;
      white-space: nowrap;
    }

    .header_partner .list-group i {
      font-size: 1.4rem;
      margin-right: 10px;
      flex-shrink: 0;
    }

    .header_partner .list-group li a {
      display: flex;
      align-items: center;
      color: inherit;
      text-decoration: none;
    }

    iframe.goog-te-banner-frame,
    .goog-te-banner-frame,
    .goog-te-balloon-frame,
    #goog-gt-tt,
    body > .skiptranslate {
      display: none !important;
      visibility: hidden !important;
      height: 0 !important;
      position: absolute !important;
      top: -9999px !important;
    }
    body {
      top: 0 !important;
    }

    .dropdown-item {
      transition: padding-left 0.2s, background-color 0.2s;
    }
    .dropdown-item:hover {
      padding-left: 1.5rem;
      background-color: #f8f9fa;
    }
    .translate-dropdown {
      right: 1rem;
      bottom: 90px !important;
      width: 40px !important;
    }
    .translate-btn {
      background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-color), 100%);
      color: #fff;
      font-size: 1.25rem;
      box-shadow: 0 6px 14px rgba(0,0,0,0.15);
    }
    .translate-btn:hover {
      transform: translateY(-2px) scale(1.05);
      box-shadow: 0 8px 18px rgba(0,0,0,0.2);
      transition: 0.25s;
    }
    .translate-btn:active {
      transform: translateY(4px) scale(0.98);
      box-shadow: 0 3px 8px rgba(0,0,0,0.1);
    }

    .restaurant-logo {
      position: fixed;
      z-index: 10;
      bottom: 90px;
      left: 3vw;
      pointer-events: none;
    }

    .logoPartner {
      height: 200px;
      width: 200px;
      object-fit: contain;
      display: block;
    }

    .restaurant-logo img {
      height: 65px;
      width: auto;
    }

    @media (min-width: 1200px) {
      .phone-icon{
        left: 47%;
        height: 50px;
        width: 6%;
      }
    }

    @media (max-width: 1200px) {
      .header_partner{
        width: 28%;
      }
      .pagePartner{
        margin-left: 28% !important;
        width: 71% !important;
      }
    }

    @media (min-width: 767px) {
      .phone-icon{
        left: 46%;
        height: 50px;
        width: 8%;
      }
      .translate-dropdown {
        left: 1.5rem;
        bottom: 0px !important;
        transform: translateY(-50%);
      }
      .translate-btn {
        font-size: 1.75rem;
      }
      
    }

    @media (max-width: 1170px) {
      #left-menu {
        width: 25%;
        transition: 3s !important;
      }
    }

    @media (max-width: 768px) {
      #left-menu {
        width: 50%;
        transition: 3s !important;
      }

      .powered{
        top: 10px;
        right: 10px;
      }

      .restaurant-logo {
        top: 10px;
        left: 10px;
        bottom: auto;
      }

      .header_partner{
        width: 50%;
        padding: 5px;
      }

      .pagePartner{
        margin-left: 0% !important;
        width: 100% !important;
      }

      .header_partner .list-group li{
        font-size: 1rem;
      }

      .header_partner .list-group i {
        font-size: 1.2rem;
      }

      .logoPartner {
        margin-top: 3vh;
        max-width: 80%;
      }
    }

    @media (max-width: 576px) {
      .header_partner{
        width: 25%
      }
      .header_partner .list-group li {
        font-size: 0.9rem;
      }

      .header_partner .list-group i {
        font-size: 1rem;
      }

      .logoPartner {
        max-width: 90%;
      }
    }

    @media (max-width: 400px) {
      .header_partner{
        width: 30%
      }
    }
</style>